export const Endpoint = () => `/api/v3/useraction/logout/`;
export const Csrf = () => `/api/v3/useraction/token/`;
export const MutationKey = () => ['v3', 'useraction', 'logout'] as const;
export type Payload = never;
export type Response = void;
